'use client';

import { PaletteMode } from '@mui/material';
import { ReactNode, useCallback, useState } from 'react';

import { ColorModeContext } from './ColorModeContext';

type ColorModeContextProviderProps = {
  mode: PaletteMode;
  children: ReactNode;
};

export const ColorModeContextProvider = ({
  mode: modeFromProps,
  children,
}: ColorModeContextProviderProps) => {
  const [mode, setMode] = useState<PaletteMode>(modeFromProps || 'dark');

  const toggleColorMode = useCallback(() => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  }, []);

  const setColorMode = useCallback((mode: PaletteMode) => {
    setMode(mode);
  }, []);

  return (
    <ColorModeContext.Provider value={{ toggleColorMode, mode, setColorMode }}>
      {children}
    </ColorModeContext.Provider>
  );
};
